import React, { useState } from 'react';
import { DocumentUpload } from '../document-upload/DocumentUpload';
import { useAuth } from '../auth/AuthContext';
export function FinancialsHistory() {
  const {
    user
  } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState('Financial Statements');
  const categories = ['Financial Statements', 'Tax Returns', 'Business Plan', 'Cash Flow Projections', 'Bank Statements', 'Other Financial Documents'];
  return <div className="bg-white rounded-lg shadow" data-id="element-2366">
    <div className="p-6" data-id="element-2367">
      <h2 className="text-xl font-semibold mb-6" data-id="element-2368">Financials & History</h2>
      <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-2369">
        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-2370">
          <h3 className="font-medium text-lg mb-4" data-id="element-2371">Business History</h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-2372">
            <div data-id="element-2373">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2374">
                Years in Business
              </label>
              <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 5" data-id="element-2375" />
            </div>
            <div data-id="element-2376">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2377">
                Annual Revenue (£)
              </label>
              <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. 1,000,000" data-id="element-2378" />
            </div>
            <div data-id="element-2379">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2380">
                Number of Employees
              </label>
              <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 25" data-id="element-2381" />
            </div>
            <div data-id="element-2382">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2383">
                Business Growth Rate (%)
              </label>
              <input type="number" className="w-full p-2 border rounded-md" placeholder="e.g. 15" data-id="element-2384" />
            </div>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-2385">
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2386">
          <h3 className="font-medium text-lg mb-4" data-id="element-2387">Financial Documents</h3>
          <div className="mb-4" data-id="element-2388">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2389">
              Document Category
            </label>
            <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-2390">
              {categories.map(category => <option key={category} value={category} data-id="element-2391">
                {category}
              </option>)}
            </select>
          </div>
          <DocumentUpload userId={user?.uid || 'demo-user'} category={selectedCategory} data-id="element-2392" />
          <div className="mt-6 text-sm text-gray-500" data-id="element-2393">
            <p data-id="element-2394">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX, CSV</p>
            <p data-id="element-2395">Maximum file size: 50MB</p>
          </div>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2396">
          <h3 className="font-medium text-lg mb-4" data-id="element-2397">Document Requirements</h3>
          <div className="space-y-4" data-id="element-2398">
            <div data-id="element-2399">
              <h4 className="font-medium" data-id="element-2400">Financial Statements</h4>
              <p className="text-sm text-gray-600" data-id="element-2401">
                Balance sheets, income statements, and cash flow statements
                for the past 3 years.
              </p>
            </div>
            <div data-id="element-2402">
              <h4 className="font-medium" data-id="element-2403">Tax Returns</h4>
              <p className="text-sm text-gray-600" data-id="element-2404">
                Business tax returns for the past 3 years.
              </p>
            </div>
            <div data-id="element-2405">
              <h4 className="font-medium" data-id="element-2406">Business Plan</h4>
              <p className="text-sm text-gray-600" data-id="element-2407">
                Current business plan including growth projections and
                strategy.
              </p>
            </div>
            <div data-id="element-2408">
              <h4 className="font-medium" data-id="element-2409">Cash Flow Projections</h4>
              <p className="text-sm text-gray-600" data-id="element-2410">
                Projected cash flow for the next 12-24 months.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
}